import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {makeGetRequest} from "../../../Services/ServicesUtils";
import {API_AUDITS} from "../../../Models/Audit/AuditEndpoints";
import GSPSBreadCrumbs from "../../../Components/Common/GSPSBreadCrumbs";
import {AuditTitle} from "../Components/auditTitle";
import {GSPSSubmitButtonStyle} from "../../../Components/Common/GSPSSubmitButton.styles";
import PropTypes from "prop-types";
import {AuditStatusID} from "../../../Models/Audit/AuditConstants";
import {AuditMediaViewerBody} from "./AuditMediaViewerBody";

export const AuditMediaViewer = ({isPublic = false}) => {
    const {auditID} = useParams();
    const [audit, setAudit] = React.useState(null);
    const [organizeView, setOrganizeView] = useState(0);

    useEffect(() => {
        makeGetRequest(`${API_AUDITS.publicAudits}${auditID}/`).then(
            (res) => {
                setAudit(res);
            },
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!audit) {
        return <div>Loading...</div>;
    }

    return <>
        <GSPSBreadCrumbs staticCrumb={`Inspection Media: ${audit.name}`} />
        <div className="container">
            <div className="intro my-4">
                <AuditTitle audit={audit} />
                <h6 className="subTitle subtitle-sm">
                    <strong>Account: </strong> {audit.account.name}. <span />
                    <strong>Project ID: </strong>
                    {audit.project_id ? audit.project_id : "-"}. <span />
                    <strong>Description: </strong>
                    {audit.description_type ? audit.description_type.name : "-"}. <span />
                </h6>
                <h6 className="subTitle subtitle-sm">
                    <strong>Audited By </strong>
                    {audit.auditor.first_name} {audit.auditor.last_name}. <span />
                    <strong>Reviewed By </strong> {audit.reviewer.first_name} {audit.reviewer.last_name}.
                </h6>
            </div>
            <div style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-start",
                flexWrap: "wrap",
            }}>
                <div className="intro my-4">
                    <GSPSSubmitButtonStyle
                        onClick={() => window.location.href = isPublic ?
                            `/public-audits/${auditID}` :
                            Number(audit.audit_status.id) === AuditStatusID.COMPLETED ?
                                    `/audits/${auditID}?report=false` :
                                    `/audits/creator?auditId=${auditID}`}
                    >
                        Back to Inspection
                    </GSPSSubmitButtonStyle>
                </div>
            </div>
            <div>
                <label htmlFor="organize-select" style={{marginRight: "10px", fontWeight: "bold"}}>
                    Organize By:
                </label>
                <select
                    id="organize-select"
                    value={organizeView}
                    onChange={(e) => setOrganizeView(Number(e.target.value))}
                    style={{
                        padding: "8px 12px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        fontSize: "14px",
                        cursor: "pointer",
                    }}
                >
                    <option value={0}>By Item Type</option>
                    <option value={1}>By Inspection Item</option>
                </select>
            </div>
            {auditID && <AuditMediaViewerBody
                key={auditID}
                auditID={Number(auditID)}
                defaultAudit={audit}
                organizeView={organizeView}
            />}
        </div>
    </>;
};

AuditMediaViewer.propTypes = {
    isPublic: PropTypes.bool,
};
